module.exports = __webpack_public_path__ + "static/media/openKey.34a5468.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/mp3/openKey.mp3
// module id = puq6
// module chunks = 1